import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import MUIDataTable from "mui-datatables";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { Paper, TableCell, TextField, Tooltip } from "@mui/material";
import useSave from "../../../Hooks/useSave";
import DataTable from "../../../components/virtulizedTable/DataTable";
import Checkbox from "@mui/material/Checkbox";
import { Box } from "@mui/material";
import { TableRow } from "@mui/material";
import { IconButton } from "@mui/material";
import { DeleteForeverOutlined } from "@mui/icons-material";

export default function EditInvoice() {
  const [isLoading, setIsLoading] = useState(true);

  const { fetchGraphql, DialogSave } = useSave(null);

  const { id } = useParams();

  const [invoice, setInvoice] = React.useState({});
  const [products, setProducts] = React.useState([]);
  const [productOptions, setProductOptions] = React.useState([]);

  useEffect(() => {
    fetchGraphql({
      query: `query Invoices($invoiceId: ID!) {
        invoiceLineItems(invoiceId: $invoiceId) {
          invoiceLineItemId
          invoiceId
          productId
          productName
          price
          quantity
          packedWeight
          combinedId
          priceByPound
        }
        invoice(invoiceId: $invoiceId) {
          invoiceId
          invoiceDate
          deliveryDate
          orderId
          customerName
          paymentStatus
          invoiceNote
          discountAmount
          discountType
          createdBy
          lastEditedBy
          billingAddress {
            addressId
            addressLine
            addressLine2
            city
            state
            zip
            comments
          }
          shippingAddress {
            addressId
            addressLine
            addressLine2
            city
            state
            zip
            comments
          }
        }
      }`,
      variables: { invoiceId: id },
    }).then((result) => {
      setInvoice(result.data.invoice);
      setProducts(result.data.invoiceLineItems);

      setIsLoading(false);

      console.log(result);
    });
  }, []);

  useEffect(() => {
    fetchGraphql({
      query: `
        query Products {
          products {
            productId
            productCode
            productName
            productDescription
            productPrice
            priceByPound
            productCategory
            productSubCategory
            productUnitOfMeasure
            productAmount
            groupId
            groupCode
            productionSheet
            sortOrder
          }
        }`,
    }).then((result) => {
      setProductOptions(result.data.products);
      setIsLoading(false);
    });
  }, []);

  const groupBy = (items, key) => {
    return items?.reduce(
      (result, item) => ({
        ...result,
        [item[key]]: [...(result[item[key]] || []), item],
      }),
      {}
    );
  };

  const groupedProducts = groupBy(
    products?.filter((item) => item.combinedId > 0),
    "combinedId"
  );

  const columns = [
    {
      id: "invoiceLineItemId",
      display: false,
    },
    {
      id: "productId",
      display: false,
    },
    {
      id: "priceByPound",
      display: false,
    },
    {
      id: "productName",
      name: "Name",
      minWidth: "200px",
      editComponent: {
        type: "selectField",
        values: productOptions?.map((item) => ({
          ...item,
          title: item.productName,
        })),
        onChange: (newValue, setRowCopy, rowCopy) => {
          setRowCopy({
            ...rowCopy,
            productName: newValue?.title || null,
            productId: newValue?.productId || null,
          });
        },
      },
    },
    {
      id: "quantity",
      dinamicId: (row) => row.priceByPound ? "packedWeight" : "quantity",
      name: "Quantity",
      align: "right",
      onChange: (e, setRowCopy, rowCopy) => {
        console.log("test", rowCopy.priceByPound, rowCopy);
        rowCopy.priceByPound 
          ? setRowCopy({
              ...rowCopy,
              packedWeight: e.target.value,
            })
          : setRowCopy({
              ...rowCopy,
              quantity: e.target.value,
            });
      },
      calculatedField: (row, rowCopy) =>
        row.priceByPound ? row.packedWeight + "  lbs" : row.quantity + " pcs",
    },
    {
      id: "price",
      name: "Price",
      align: "right",
    },
    {
      id: "totalPrice",
      name: "Total Price",
      align: "right",
      edit: false,
      calculatedField: (row, rowCopy) =>
        row.priceByPound
          ? "$ " + (row.packedWeight * row.price).toFixed(2)
          : "$ " + (row.quantity * row.price).toFixed(2),
    },
  ];

  const options = {
    columnAlign: "left",
    columnMinWidth: "100px",
    toolbar: false,
    customRows:
      Object.keys(groupedProducts).map((item) => groupedProducts[item][0])[0] &&
      Object.keys(groupedProducts).map((item) => {
        return (
          <TableRow
            sx={{
              // minWidth: 650,
              minWidth: "100%",
              display: "flex",
              flexDirection: "row",
              alignContent: "center",
              height: "100%",
              overflow: "auto",
              borderTop: "solid 1px #e0e0e0 !important",
              borderBottom: "solid 1px #e0e0e0 !important",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignContent: "center",
                width: "80%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "25%",
                }}
              >
                {groupedProducts[item]?.map((row) => (
                  <Box
                    sx={{
                      display: "flex",
                      alignContent: "center",
                      width: "100%",
                      borderBottom: "1px solid #e0e0e0",
                      "&:last-child": {
                        border: 0,
                      },
                    }}
                  >
                    <TableCell
                      sx={{
                        width: "100%",
                        minWidth: "100px",
                        alignSelf: "center",
                        minHeight: "50px",
                        border: "none !important",
                      }}
                    >
                      {row.productName}
                    </TableCell>
                  </Box>
                ))}
              </Box>
              <TableCell
                sx={{
                  alignSelf: "center",
                  // height: "100%",
                  width: "25%",
                  textAlign: "right",
                  minWidth: "100px",
                  border: "none !important",
                }}
              >
                <TextField
                  size="small"
                  type="number"
                  value={groupedProducts[item][0].packedWeight}
                  onChange={(e) => {
                    const copyState = [...products];

                    for (const orderProduct of groupedProducts[item]) {
                      const row = copyState.find(
                        (row) =>
                          row.orderProductId === orderProduct.orderProductId
                      );

                      row.packedWeight = e.target.value;
                    }

                    setProducts(copyState);
                  }}
                />
              </TableCell>
              <TableCell
                sx={{
                  alignSelf: "center",
                  // height: "100%",
                  textAlign: "right",
                  width: "25%",
                  minWidth: "100px",
                  border: "none !important",
                }}
              >
                {groupedProducts[item][0].packedWeight}
              </TableCell>
              <TableCell
                sx={{
                  alignSelf: "center",
                  // height: "100%",
                  textAlign: "right",
                  width: "25%",
                  minWidth: "100px",
                  border: "none !important",
                }}
              >
                {groupedProducts[item][0].packedWeight}
              </TableCell>
            </Box>

            <Box
              sx={{
                borderLeft: "dotted 1px gray !important",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TableCell
                sx={{
                  alignSelf: "center",
                  height: "100%",
                  width: "20%",
                  border: "none !important",
                  minWidth: "190px",
                  minHeight: "50px",
                }}
              >
                <Tooltip title="Delete">
                  <IconButton
                    onClick={() => {
                      const copyState = [...products];

                      for (const orderProduct of groupedProducts[item]) {
                        const row = copyState.find(
                          (row) =>
                            row.orderProductId === orderProduct.orderProductId
                        );

                        row.combinedId = null;
                        row.packedWeight = null;
                      }

                      setProducts(copyState);
                    }}
                  >
                    <DeleteForeverOutlined sx={{ color: "error.light" }} />
                  </IconButton>
                </Tooltip>
              </TableCell>
            </Box>
          </TableRow>
        );
      }),
    save: (rowCopy, row) => {
      const copyState = [...products];

      const product = copyState.find(
        (item) => item["productId"] === row.productId
      );

      const productIndex = copyState.findIndex(
        (item) => item["productId"] === row.productId
      );

      //dont forget to handle quantity acourding to price by pound

      const { productId, groupCode, ...newProduct } = rowCopy;

      if (product.productId.includes("new")) {
        return fetchGraphql({
          query: `mutation CreateProduct($product: ProductInput) {
            createProduct(product: $product)
          }`,
          variables: { product: newProduct },
        }).then((result) => {
          rowCopy.productId = result.data.createProduct;

          copyState[productIndex] = rowCopy;

          setProducts(copyState);

          return Promise.resolve("done");
        });
      } else {
        // console.log("old");
        return fetchGraphql({
          query: `mutation UpdateProduct($productId: ID, $product: ProductInput) {
            updateProduct(productId: $productId, product: $product)
          }`,
          variables: {
            product: newProduct,
            productId: product.productId,
          },
        }).then((result) => {
          newProduct.productId = product.productId;

          copyState[productIndex] = rowCopy;

          setProducts(copyState);
        });
      }
    },
    delete: (row) => {
      const copyState = [...products];

      const productIndex = copyState.findIndex(
        (item) => item["productId"] === row.productId
      );

      if (!row.productId.includes("new")) {
        fetchGraphql({
          query: `mutation DeleteProduct($productId: ID) {
            deleteProduct(productId: $productId)
          }`,
          variables: {
            productId: row["productId"],
          },
        }).then((result) => {
          copyState.splice(productIndex, 1);

          setProducts(copyState);
        });
      } else {
        copyState.splice(productIndex, 1);

        setProducts(copyState);
      }
    },
    newRecord: (setEditIndex, setRowCopy) => {
      const copyState = [...products];

      const newIngredient = {
        productId: `new${products.length + 1}`,
        productCode: "",
        productName: "",
        productDescription: "",
        productCategory: "",
        sortOrder: null,
        productPrice: null,
        priceByPound: null,
        productSubCategory: null,
        productUnitOfMeasure: null,
        productAmount: null,
        groupId: null,
        groupCode: null,
        productionSheet: null,
      };

      copyState.push(newIngredient);

      setRowCopy(newIngredient);

      setProducts(copyState);

      setEditIndex({ rowIndex: copyState.length - 1, columnIndex: 1 });
    },
    fob: (setEditIndex, setRowCopy) => {
      const copyState = [...products];

      const newIngredient = {
        productId: `new${products.length + 1}`,
        productCode: "",
        productName: "",
        productDescription: "",
        productCategory: "",
        sortOrder: null,
        productPrice: null,
        priceByPound: null,
        productSubCategory: null,
        productUnitOfMeasure: null,
        productAmount: null,
        groupId: null,
        groupCode: null,
        productionSheet: null,
      };

      copyState.push(newIngredient);

      setRowCopy(newIngredient);

      setProducts(copyState);

      setEditIndex({ rowIndex: copyState.length - 1, columnIndex: 1 });
    },
    isLoading,
  };

  return (
    <Paper
      sx={{
        width: "100%",
        height: "100%",
        marginRight: "20px",
        padding: "20px",
        overflow: "auto",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <DataTable
        rows={products.filter(
          (item) => item.combinedId <= 0 || item.combinedId === null
        )}
        columns={columns}
        options={options}
      />
    </Paper>
  );
}
